import React, { useRef } from 'react'
import { motion, useInView } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

function RevealCard({ index, initialY, initialOpacity, duration, staggerDelay }: {
  index: number
  initialY: number
  initialOpacity: number
  duration: number
  staggerDelay: number
}) {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: false, margin: '-20px' })

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: initialOpacity, y: initialY }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: initialOpacity, y: initialY }}
      transition={{ duration, delay: index * staggerDelay }}
      className="h-16 bg-white rounded-lg shadow-sm border border-gray-100 flex items-center px-4 shrink-0"
    >
      <div className="w-8 h-8 rounded-full bg-indigo-100 mr-3 shrink-0" />
      <div className="flex-1">
        <div className="h-2.5 bg-gray-200 rounded w-3/4 mb-1.5" />
        <div className="h-2 bg-gray-100 rounded w-1/2" />
      </div>
    </motion.div>
  )
}

export function RevealOnScroll({ values = {} }: { values?: FieldValues }) {
  const initialY = values.initialY ?? 30
  const initialOpacity = values.initialOpacity ?? 0
  const duration = values.duration ?? 0.5
  const staggerDelay = values.staggerDelay ?? 0.1
  const itemCount = values.itemCount ?? 8

  return (
    <div className="h-full overflow-y-auto p-3 space-y-3">
      {Array.from({ length: itemCount }, (_, i) => (
        <RevealCard
          key={i}
          index={i}
          initialY={initialY}
          initialOpacity={initialOpacity}
          duration={duration}
          staggerDelay={staggerDelay}
        />
      ))}
    </div>
  )
}
